module.exports = __webpack_public_path__ + "static/media/time-left.087ff188.svg";